module.exports = __webpack_public_path__ + "img/dd-logo-chevy-w.3b25ceee.png";